import { useEffect, useState } from 'react';
import { isNewFrontendRelease } from '../../services/frontendRelease';

export default function FrontendVersionNotice() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    if (import.meta.env.DEV) return;
    let stopped = false;
    let pending = false;
    const controller = new AbortController();
    const check = async () => {
      if (pending || stopped) return;
      pending = true;
      try {
        const response = await fetch('/frontend-release.json', { cache: 'no-store', signal: controller.signal });
        if (!response.ok) return;
        const manifest = await response.json();
        if (!stopped) setAvailable(isNewFrontendRelease(__FRONTEND_BUILD_ID__, manifest));
      } catch { /* Offline / staggered deploy: do not interrupt work or imply a backend failure. */ }
      finally { pending = false; }
    };
    void check();
    window.addEventListener('focus', check);
    return () => { stopped = true; controller.abort(); window.removeEventListener('focus', check); };
  }, []);
  if (!available) return null;
  return <div role="status" className="fixed bottom-3 right-3 z-[1000] max-w-md rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
    有新版本，请保存当前草稿后刷新。刷新不会取消后台任务。
    <button className="ml-2 underline" type="button" onClick={() => {
      if (window.confirm('刷新会清空尚未提交的页面草稿；后台任务继续运行。确认已保存？')) window.location.reload();
    }}>刷新页面</button>
  </div>;
}
